import { Signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

import { ColumnTypeEnum } from '~components/dynamic-table/models/enums/column-type.enum';
import { TextAlignmentEnum } from '~core/models/enums/text-alignment.enum';

export abstract class BaseColumnModel {
    columnTitleKey!: string;
    columnTitleSuffix?: string;
    columnTitleAlignment = TextAlignmentEnum.Left;
    shouldHideColumnTitle? = false;
    propertyName?: string;
    sortColumn?: string;
    widthPixels!: number;
    allowSort = true;
    isCompact = false;
    isEditable = false;
    isDisabled = false;
    titleSignal?: Signal<string>;
    actionIcon?: string;
    action?: (control: FormControl) => Observable<any>;
    customFormatter?: (record: any, value: any, propertyName?: string) => string;
    isBold?: (record: any, value: any, propertyName?: string) => boolean;
    tooltip?: (data: any) => string;

    protected constructor(
        readonly columnType: ColumnTypeEnum,
        init?: Partial<BaseColumnModel>
    ) {
        if (!!init) {
            Object.assign(this, init);
        }
    }

    get identifier(): string {
        return this.propertyName ?? this.columnTitleKey;
    }
}
